import React from 'react';
import { Amplify } from 'aws-amplify';
import HilbertVisualization from './HilbertVisualization';
import './App.css';
import amplifyconfig from './amplifyconfiguration.json';

Amplify.configure(amplifyconfig);

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Hilby React App</h1>
        <p>Interactive Hilbert Curve Visualization for IP Address Spaces</p>
        <p style={{ fontSize: '0.9rem', opacity: 0.7, marginTop: '10px' }}>
          Ready for IP prefix and ROA data integration
        </p>
      </header>
      <main>
        <HilbertVisualization />
      </main>
    </div>
  );
}

export default App;
